var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28404 0.428711H13.5698L19.9983 6.85728V23.2859C19.9983 23.6647 19.8478 24.0281 19.5799 24.296C19.312 24.5639 18.9486 24.7144 18.5698 24.7144H4.28404C3.90516 24.7144 3.5418 24.5639 3.27389 24.296C3.00598 24.0281 2.85547 23.6647 2.85547 23.2859V1.85728C2.85547 1.4784 3.00598 1.11504 3.27389 0.84713C3.5418 0.579221 3.90516 0.428711 4.28404 0.428711ZM17.8555 6.85728L13.5698 2.57157V6.143C13.5698 6.33244 13.645 6.51412 13.779 6.64807C13.9129 6.78203 14.0946 6.85728 14.284 6.85728H17.8555ZM16.2176 12.0666C16.3515 12.2005 16.4267 12.3822 16.4267 12.5716C16.4267 12.761 16.3515 12.9426 16.2176 13.0766L9.99833 19.2959L6.63618 15.9337C6.50607 15.799 6.43407 15.6186 6.4357 15.4313C6.43733 15.244 6.51245 15.0648 6.64488 14.9324C6.77732 14.8 6.95647 14.7249 7.14375 14.7232C7.33104 14.7216 7.51147 14.7936 7.64618 14.9237L9.99833 17.2759L15.2076 12.0666C15.3416 11.9327 15.5232 11.8574 15.7126 11.8574C15.902 11.8574 16.0837 11.9327 16.2176 12.0666Z",
    fill: "#BD69FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42857 4.71387H0V23.9996C0 24.9468 0.376274 25.8552 1.04605 26.525C1.71582 27.1947 2.62423 27.571 3.57143 27.571H17.1429V26.1424H3.57143C3.00311 26.1424 2.45806 25.9167 2.0562 25.5148C1.65434 25.1129 1.42857 24.5679 1.42857 23.9996V4.71387Z",
    fill: "#BD69FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericFile);
export default __webpack_public_path__ + "static/media/generic-file.4467c11d6cd53eb9d1b77f085ee2aa6c.svg";
export { ForwardRef as ReactComponent };